export default "__VITE_ASSET__81e68151__"